import moment from 'moment';
import formatString from 'utils/formatString';

const collectBirth = elephant => ({
  date: moment(elephant.birth),
  title: 'Birth',
  type: 'birth',
  details: elephant.cw !== 'UKN' && formatString(elephant.cw),
});

const collectCaptured = (elephant) => {
  if (elephant.age_capture) {
    return {
      date: moment(elephant.birth).add(elephant.age_capture, 'years'),
      title: 'Captured',
      details: `Age ${elephant.age_capture}`,
      type: 'capture',
    };
  }
  return null;
};

const collectEvents = elephant => elephant.events.map((event) => {
  if (event.date && event.code) {
    let eventType = null;
    if (event.code.class_field === 'death' || event.code.class_field === 'capture') {
      eventType = event.code.class_field;
    }
    if (event.code.type === 'logbook_start' || event.code.type === 'logbook_end') {
      eventType = event.code.type;
    }
    return {
      date: moment(event.date),
      title: `${formatString(event.code.class_field)} / ${formatString(event.code.type)}`,
      details: event.code.descript,
      location: event.loc,
      class: event.code.class_field,
      type: eventType,
    };
  }
  return null;
});

const collectPedigrees = elephant => elephant.pedigrees.map((pedigree) => {
  if (pedigree.elephant_1 && pedigree.elephant_2
      && pedigree.elephant_1.pk === elephant.pk
      && (pedigree.rel === 'mother' || pedigree.rel === 'father')) {
    return {
      date: moment(pedigree.elephant_2.birth),
      title: pedigree.rel === 'mother'
        ? 'Gave birth to'
        : 'Calf was born',
      details: pedigree.elephant_2.name
        ? pedigree.elephant_2.name.length < 24
          ? pedigree.elephant_2.name
          : `${pedigree.elephant_2.name.slice(0, 24)}...`
        : '( No name )',
      type: 'reproduction',
      linkedElephant: pedigree.elephant_2.pk,
    };
  }
  return null;
});


export default function (elephant) {
  /* returns a sorted list of events */
  let items = [];

  items.push(collectBirth(elephant));
  items.push(collectCaptured(elephant));

  items = items.concat(collectEvents(elephant));
  items = items.concat(collectPedigrees(elephant));

  items = items.filter(i => i !== null);
  items.sort((a, b) => {
    // move unknown dates to the end of the list
    if (a.date === null) return 1;
    if (b.date === null) return -1;
    // otherwise sort by date
    return a.date.isAfter(b.date) ? 1 : -1;
  });
  items.forEach((item, index) => { item.key = index; });
  return items;
}



// WEBPACK FOOTER //
// ./src/layout/withElephant/collectEvents.js